import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';

import {searchList} from '../../store/modules/searchList';
import {bookmarkList, bookmarkListAddPro, bookmarkListAddServ} from '../../store/modules/bookmarkList';
import {StorageContainer} from '../../styled/CommonStyle';
import styled from "styled-components";
import ErrorBox from "./Error";
import TierTag from "./TierTag";
import InfluIcon from "../summoner/Profile/InfluInfo/InfluIcon";


const AbsoluteBox = styled.div`
  width: 100%;
  padding: 10px;
  height: 100%;
  position: absolute;
  top: 50px;
  z-index: 99;

  .errorStyle {
    padding: 10px;
  }
`;

const NodataWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 200px;
  color: ${props => props.theme.color.dark_100};
  background-color: ${props => props.theme.color.site_main_color};
`;

const RegionTagWrapper = styled.div`
  .tier_badge {
    display: flex;
    align-content: center;
    justify-content: center;
    width: 24px;
    height: 14px;
    line-height: 15px;
    font-size: 11px;
    border-radius: 5px;

    &.challenger {
      font-size: 11px;
    }

    &.grandmaster {
      width: 24px;
      font-size: 11px;

    }

    &.master {
      font-size: 11px;
    }
  }

`;

const TagText = styled.span`
  color: ${props => props.theme.color.dark_200};
  font-size: 14px;
  margin-left: 5px;
`;
const SearchList = ({
                        fullWidth, onSelect = () => {
    }
                    }) => {
    const dispatch = useDispatch();
    const bookmarks = useSelector((state) => state.bookmarkList.bookmarks);
    const region = useSelector((state) => state.region.result);
    const searchs = useSelector((state) => state.searchList.searchs);
    const [openError, setOpenError] = useState(false);
    const viewSearchs = [...searchs].reverse().slice(0, 10);
    const {t} = useTranslation();


    // 북마크 추가/제거
    const toggleBookmark = (item) => {
        let arr = bookmarks.filter((itm) => itm?.summoner_basic_info_dict?.puu_id === item?.summoner_basic_info_dict?.puu_id);
        arr.length !== 0 ? dispatch(bookmarkList(item, 'remove'))
            :
            bookmarks.length > 9 ? opencloseError() :
                dispatch(bookmarkList({
                    ...item,
                    region: item.region ? item.region : region
                }, 'add'));
    };

    const toggleProBookmark = (item) => {
        let arr = bookmarks.filter((itm) => itm.type === 'influencer' && itm?.url_name === item?.url_name);
        arr.length !== 0 ? dispatch(bookmarkList(item, 'remove'))
            :
            bookmarks.length > 9 ? opencloseError() :
                dispatch(bookmarkListAddPro({
                    ...item,
                }));
    }

    const toggleServerBookmark = (item) => {
        let arr = bookmarks.filter((itm) => itm.type === 'server' && itm?.server_id === item?.server_id);
        arr.length !== 0 ? dispatch(bookmarkList(item, 'remove'))
            :
            bookmarks.length > 9 ? opencloseError() :
                dispatch(bookmarkListAddServ({
                    ...item,
                }));
    }

    // 최근검색 항목 제거
    const removeSearch = (item) => {
        dispatch(searchList(item, 'remove'));
    };

    const opencloseError = () => {
        setOpenError(true);
        setTimeout(() => {
            setOpenError(false);
        }, 2000);
    };


    return (
        <StorageContainer fullWidth={fullWidth} className={'searchListContainer'}>
            {openError &&
                <AbsoluteBox>
                    <ErrorBox
                        infoText={t('error.favorite_excess')}
                    />
                </AbsoluteBox>}
            {searchs.length !== 0 ? (
                <ul className="search_list">
                    {viewSearchs.map((item, index) => {
                        if (item.type === 'server') {
                            const isOn = bookmarks.find((data) => data.server_id === item.server_id);
                            return (
                                <SearchListPro
                                    ImageComponent={
                                        <img src={'/images/img_tag_server.svg'} width={40}
                                             alt={""}
                                             height={16}/>
                                    }
                                    onSelect={onSelect} to={`/connect/${item.server_id}`}
                                    name={item.server_name} item={item}
                                    isOn={isOn} removeSearch={removeSearch}
                                    toggleBookMark={toggleServerBookmark}
                                    key={index}
                                />
                            )
                        }

                        if (item.type === 'influencer') {
                            const isFavoriteInflue = bookmarks.find((data) => data.url_name === item.url_name);
                            return (
                                <SearchListPro onSelect={onSelect} to={`/${item.url_tag}/${item.url_name}`}
                                               name={item.name} item={item}
                                               ImageComponent={<InfluIcon status={item.status}/>}
                                               isOn={isFavoriteInflue} removeSearch={removeSearch}
                                               toggleBookMark={toggleProBookmark}
                                               key={index}
                                />
                            )
                        }

                        const bookmarkArr = bookmarks.filter((itm) => item?.summoner_basic_info_dict?.puu_id === itm?.summoner_basic_info_dict?.puu_id);
                        return (
                            <li key={index}>
                                <RegionTagWrapper>
                                    <TierTag
                                        fontSize={'11px'}
                                        padding={'4px 4px'}
                                        tier={item?.season_tier_info_dict?.ranked_solo_5x5?.tier}
                                        division={item?.season_tier_info_dict?.ranked_solo_5x5?.division}
                                    />
                                </RegionTagWrapper>
                                <p className="txt" onClick={onSelect}>
                                    <Link
                                        to={`/summoner/${item.region?.toLowerCase() ? item.region?.toLowerCase() : region}/${item?.summoner_basic_info_dict?.riot_id_name}-${item?.summoner_basic_info_dict?.riot_id_tag_line}`}
                                        className="common_search">
                                        {decodeURI(item?.summoner_basic_info_dict?.riot_id_name)}<TagText>#{decodeURI(item?.summoner_basic_info_dict?.riot_id_tag_line)}</TagText>
                                    </Link>
                                </p>
                                <button
                                    className={`bookmark ${bookmarkArr.length !== 0 ? 'on' : 'off'}`}
                                    onClick={() => toggleBookmark(item)}
                                >
                                    {t('buttons.favorite')}
                                </button>
                                <button className="remove" onClick={() => removeSearch(item)}>
                                    {t('buttons.delete')}
                                </button>
                            </li>
                        );
                    })}
                </ul>
            ) : (
                <NodataWrapper>
                    <p className="no_list">{t('persist.noRecentSearch')}</p>
                </NodataWrapper>
            )}
        </StorageContainer>
    );
};


const SearchListPro = ({ImageComponent, to, name, onSelect, isOn, toggleBookMark, removeSearch, item}) => {
    const {t} = useTranslation();

    return (
        <li>
            {ImageComponent}
            {/*<InfluIcon status={item.status}/>*/}
            <p className="txt" onClick={onSelect}>
                {/*<Link*/}
                {/*    to={`/${item.url_tag}/${item.url_name}`}*/}
                {/*    className="common_search">*/}
                {/*    {item.name}*/}
                {/*</Link>*/}
                <Link
                    to={to}
                    className="common_search">
                    {name}
                </Link>
            </p>
            <button
                className={`bookmark ${isOn ? 'on' : 'off'}`}
                onClick={() => toggleBookMark(item)}
            >
                {t('buttons.favorite')}
            </button>
            <button className="remove" onClick={() => removeSearch(item)}>
                {t('buttons.delete')}
            </button>
        </li>
    )
}

export default SearchList;
